// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-screen {
  border-bottom: 0.92px solid #4E4E4E;
  height: 9vh;
  margin-left: 70px;
  margin-right: 70px;
}
@media (max-width: 768px) {
  .header-screen {
    height: 7vh; /* Adjust height for smaller screens */
    margin-left: 20px;
    margin-right: 20px;
  }
}

.header-screen .row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
@media (max-width: 768px) {
  .header-screen .row {
    flex-direction: column; /* Stack columns in smaller screens */
    align-items: flex-start; /* Align items to the start */
  }
}

.header-screen .col-sm-2 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 8px;
}
@media (max-width: 768px) {
  .header-screen .col-sm-2 {
    margin-top: 5px; /* Adjust margin for smaller screens */
  }
}

.header-icon {
  margin-right: 10px;
  width: 20px; /* Adjust icon size as needed */
  height: auto;
}
@media (max-width: 768px) {
  .header-icon {
    width: 15px; /* Adjust icon size for smaller screens */
  }
}

.new-chat {
  display: flex;
  flex-direction: row;
  background-color: rgb(26, 29, 33);
  border-radius: 7px;
  width: 12%;
  margin-top: 12px;
  height: 30px;
}
@media (max-width: 768px) {
  .new-chat {
    width: 30%; /* Adjust width for smaller screens */
    margin-top: 8px; /* Adjust margin for smaller screens */
    height: 20px; /* Adjust height for smaller screens */
  }
}

.new-chat img {
  width: 15%;
  margin-left: 10px;
}
@media (max-width: 768px) {
  .new-chat img {
    width: 20%; /* Adjust icon size for smaller screens */
    margin-left: 5px; /* Adjust margin for smaller screens */
  }
}

.new-chat-text {
  margin-top: 5px;
  margin-left: 5px;
  font-size: 12px;
  color: white;
}
@media (max-width: 768px) {
  .new-chat-text {
    font-size: 10px; /* Adjust font size for smaller screens */
    margin-left: 3px; /* Adjust margin for smaller screens */
  }
}

/* HeaderScreen.scss */
.toggle-section {
  display: flex;
  align-items: center;
}

.toggle-label {
  font-size: 14px;
  margin-right: 20px;
  color: white;
}

.toggle-switch {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 20px;
  width: 40px;
  height: 20px;
  position: relative;
  cursor: pointer;
  padding: 0;
}

.toggle-knob {
  background-color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  position: absolute;
  top: 1px;
  transition: left 0.3s;
}`, "",{"version":3,"sources":["webpack://./src/component/screens/HeaderScreen.scss"],"names":[],"mappings":"AAAA;EACI,mCAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AACJ;AACI;EANJ;IAOM,WAAA,EAAA,sCAAA;IACA,iBAAA;IACA,kBAAA;EAEJ;AACF;;AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AAEJ;AAAI;EANF;IAOI,sBAAA,EAAA,qCAAA;IACA,uBAAA,EAAA,6BAAA;EAGJ;AACF;;AAAE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AAGJ;AADI;EANF;IAOI,eAAA,EAAA,sCAAA;EAIJ;AACF;;AADE;EACE,kBAAA;EACA,WAAA,EAAA,+BAAA;EACA,YAAA;AAIJ;AAFI;EALF;IAMI,WAAA,EAAA,yCAAA;EAKJ;AACF;;AAFE;EACE,aAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AAKJ;AAHI;EATF;IAUI,UAAA,EAAA,qCAAA;IACA,eAAA,EAAA,sCAAA;IACA,YAAA,EAAA,sCAAA;EAMJ;AACF;;AAHE;EACE,UAAA;EACA,iBAAA;AAMJ;AAJI;EAJF;IAKI,UAAA,EAAA,yCAAA;IACA,gBAAA,EAAA,sCAAA;EAOJ;AACF;;AAJE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAOJ;AALI;EANF;IAOI,eAAA,EAAA,yCAAA;IACA,gBAAA,EAAA,sCAAA;EAQJ;AACF;;AALE,sBAAA;AACF;EACE,aAAA;EACA,mBAAA;AAQF;;AALA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;AAQF;;AALA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;AAQF;;AALA;EACE,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;AAQF","sourcesContent":[".header-screen {\n    border-bottom: 0.92px solid #4E4E4E;\n    height: 9vh;\n    margin-left: 70px;\n    margin-right: 70px;\n  \n    @media (max-width: 768px) {\n      height: 7vh; /* Adjust height for smaller screens */\n      margin-left: 20px;\n      margin-right: 20px;\n    }\n  }\n  \n  .header-screen .row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 100%;\n  \n    @media (max-width: 768px) {\n      flex-direction: column; /* Stack columns in smaller screens */\n      align-items: flex-start; /* Align items to the start */\n    }\n  }\n  \n  .header-screen .col-sm-2 {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    margin-top: 8px;\n  \n    @media (max-width: 768px) {\n      margin-top: 5px; /* Adjust margin for smaller screens */\n    }\n  }\n  \n  .header-icon {\n    margin-right: 10px;\n    width: 20px; /* Adjust icon size as needed */\n    height: auto;\n  \n    @media (max-width: 768px) {\n      width: 15px; /* Adjust icon size for smaller screens */\n    }\n  }\n  \n  .new-chat {\n    display: flex;\n    flex-direction: row;\n    background-color: rgba(26, 29, 33, 1);\n    border-radius: 7px;\n    width: 12%;\n    margin-top: 12px;\n    height: 30px;\n  \n    @media (max-width: 768px) {\n      width: 30%; /* Adjust width for smaller screens */\n      margin-top: 8px; /* Adjust margin for smaller screens */\n      height: 20px; /* Adjust height for smaller screens */\n    }\n  }\n  \n  .new-chat img {\n    width: 15%;\n    margin-left: 10px;\n  \n    @media (max-width: 768px) {\n      width: 20%; /* Adjust icon size for smaller screens */\n      margin-left: 5px; /* Adjust margin for smaller screens */\n    }\n  }\n  \n  .new-chat-text {\n    margin-top: 5px;\n    margin-left: 5px;\n    font-size: 12px;\n    color: white;\n  \n    @media (max-width: 768px) {\n      font-size: 10px; /* Adjust font size for smaller screens */\n      margin-left: 3px; /* Adjust margin for smaller screens */\n    }\n  }\n\n  /* HeaderScreen.scss */\n.toggle-section {\n  display: flex;\n  align-items: center;\n}\n\n.toggle-label {\n  font-size: 14px;\n  margin-right: 20px;\n  color: white;\n}\n\n.toggle-switch {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 20px;\n  width: 40px;\n  height: 20px;\n  position: relative;\n  cursor: pointer;\n  padding: 0;\n}\n\n.toggle-knob {\n  background-color: white;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  position: absolute;\n  top: 1px;\n  transition: left 0.3s;\n}\n\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
